const ACTIVITES_DATA = {
  jack_o_lantern: '🎃',
  christmas_tree: '🎄',
  fireworks: '🎆',
  sparkler: '🎇',
  firecracker: '🧨',
  sparkles: '✨',
  balloon: '🎈',
  party_popper: '🎉',
  confetti_ball: '🎊',
  tanabata_tree: '🎋',
  pine_decoration: '🎍',
  japanese_dolls: '🎎',
  carp_streamer: '🎏',
  wind_chime: '🎐',
  moon_viewing_ceremony: '🎑',
  red_envelope: '🧧',
  ribbon: '🎀',
  wrapped_gift: '🎁',
  reminder_ribbon: '🎗',
  admission_tickets: '🎟',
  ticket: '🎫',
  military_medal: '🎖',
  trophy: '🏆',
  sports_medal: '🏅',
  '1st_place_medal': '🥇',
  '2nd_place_medal': '🥈',
  '3rd_place_medal': '🥉',
  soccer_ball: '⚽',
  baseball: '⚾',
  softball: '🥎',
  basketball: '🏀',
  volleyball: '🏐',
  american_football: '🏈',
  rugby_football: '🏉',
  tennis: '🎾',
  flying_disc: '🥏',
  bowling: '🎳',
  cricket_game: '🏏',
  field_hockey: '🏑',
  ice_hockey: '🏒',
  lacrosse: '🥍',
  ping_pong: '🏓',
  badminton: '🏸',
  boxing_glove: '🥊',
  martial_arts_uniform: '🥋',
  goal_net: '🥅',
  flag_in_hole: '⛳',
  ice_skate: '⛸',
  fishing_pole: '🎣',
  diving_mask: '🤿',
  running_shirt: '🎽',
  skis: '🎿',
  sled: '🛷',
  curling_stone: '🥌',
  bullseye: '🎯',
  yo_yo: '🪀',
  kite: '🪁',
  water_pistol: '🔫',
  pool_8_ball: '🎱',
  crystal_ball: '🔮',
  magic_wand: '🪄',
  video_game: '🎮',
  joystick: '🕹',
  slot_machine: '🎰',
  game_die: '🎲',
  puzzle_piece: '🧩',
  teddy_bear: '🧸',
  pinata: '🪅',
  mirror_ball: '🪩',
  nesting_dolls: '🪆',
  spade_suit: '♠',
  heart_suit: '♥',
  diamond_suit: '♦',
  club_suit: '♣',
  chess_pawn: '♟',
  joker: '🃏',
  mahjong_red_dragon: '🀄',
  flower_playing_cards: '🎴',
  performing_arts: '🎭',
  framed_picture: '🖼',
  artist_palette: '🎨',
  thread: '🧵',
  sewing_needle: '🪡',
  yarn: '🧶',
  knot: '🪢',
};

export default ACTIVITES_DATA;
